import React, { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth/store';
import { get } from "@rails/request.js";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/auth/login';
import Register from '@/pages/auth/signup';
import ForgotPassword from '@/pages/auth/forgot';
import HomeOrLanding from "@/pages/HomeOrLanding";
import SidebarExample from "./pages/sidebar";
import SitesIndex from "./pages/sites";
import SiteShow from "./pages/sites/show";
import SiteThemes from "./pages/sites/SiteThemes";
import ThemeEdit from "./pages/sites/ThemeEdit";
import SiteCollaborators from "./pages/sites/SiteCollaborators";
import SiteDeployments from "./pages/sites/SiteDeployments";
import SitePosts from "./pages/sites/SitePosts";
import SitePostEdit from "./pages/sites/SitePostEdit";
import ProductsIndex from "./pages/sites/ProductsIndex";
import ProductNew from "./pages/sites/ProductNew";
import ProductEdit from "./pages/sites/ProductEdit";
import SiteEditPage from "@/pages/sites/SiteEditPage";
import Authentications from "./pages/Authentications";
import StripeConnectSettings from "./pages/StripeConnectSettings";
import ProtectedRoute from "@/components/ProtectedRoute";
import DevEditorNew from "./pages/sites/DevEditorNew";
import DevEditorConversations from "./pages/sites/DevEditorConversations";

const queryClient = new QueryClient();

function App() {
  const {setUser, user} = useAuthStore();

  console.log("App user", user);
  useEffect(() => {
    (async () => {
      try {
        const response = await get("/me.json", { responseKind: "json" });
        if (response && response.ok) {
          const user = await response.json;
          if (user && user.id && user.email) {
            setUser(user);
          }
        }
      } catch {
        // Not authenticated or error, do nothing
      }
    })();
  }, [setUser]);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* Public landing page or app, reactive to user state */}
          <Route path="/" element={<HomeOrLanding />}>
            {/* Protected internal app routes */}
            <Route index element={<SitesIndex />} />
            <Route element={<ProtectedRoute />}>
              <Route path="sites" element={<SitesIndex />} />
              <Route path="sites/:siteSlug" element={<SiteShow />} />
              <Route path="sites/:siteSlug/pages" element={<SiteShow />} />
              <Route path="sites/:siteSlug/settings" element={<SiteEditPage />} />
              <Route path="sites/:siteSlug/themes" element={<SiteThemes />} />
              <Route path="sites/:siteSlug/themes/:themeId/edit" element={<ThemeEdit />} />
              <Route path="sites/:siteSlug/collaborators" element={<SiteCollaborators />} />
              <Route path="sites/:siteSlug/devEditor/conversations" element={<DevEditorConversations />} />
              <Route path="sites/:siteSlug/devEditor/:themeBuildId" element={<DevEditorNew />} />
              <Route path="sites/:siteSlug/devEditor" element={<DevEditorNew />} />
              <Route path="sites/:id/settings" element={<div className="p-6">Site Themes (/:id/themes)</div>} />
              <Route path="sites/:siteSlug/deployments" element={<SiteDeployments />} />
              <Route path="sites/:siteSlug/posts" element={<SitePosts />} />
              <Route path="sites/:siteSlug/posts/:postSlug" element={<SitePostEdit />} />
              <Route path="sites/:siteSlug/products" element={<ProductsIndex />} />
              <Route path="sites/:siteSlug/products/new" element={<ProductNew />} />
              <Route path="sites/:siteSlug/products/:productId/edit" element={<ProductEdit />} />
              <Route path="authentications" element={<Authentications />} />
              <Route path="stripe_connect" element={<StripeConnectSettings />} />
            </Route>
          </Route>
        </Routes>
      </Router>
      <Toaster />
      {/*<ReactQueryDevtools initialIsOpen={false} />*/}
    </QueryClientProvider>
  );
}

export default App;
